import React, { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import allPaths from "../../Config/paths"
import serviceImg from '../../secondAssets/Images/serviceSection.png'
import { serviceData } from "../../secondUtils/constants";
import ServiceHeader from "../ServiceHeader/ServiceHeader";

const Service = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'

    return (
        <div className="main">
            <div className="second-design-service-container">
                <ServiceHeader serviceHeaderImg={serviceImg} serviceHeading={selectedLanguage?.our_services_heading} serviceText={selectedLanguage?.txt_smile_youre_designed_to} />
                <div className="service-cards-main">
                    {
                        serviceData?.slice(0, 3).map((v, i) => {
                            return (
                                <div data-aos="fade-up"
                                    data-aos-easing="ease-out-bounce"
                                    data-aos-delay="300"
                                    data-aos-duration="2000">
                                    <img src={v?.imageUrl} alt="" />
                                    <h2>
                                        {isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                    </h2>
                                    <p>
                                        {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                    </p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default Service;
